import { identidadeDaRede } from "../../helpers/canalDoTicket.jsx";

// Nome, glifo e cor de cada rede vêm de helpers/canalDoTicket — o mesmo mapa
// que marca o canal na lista de tickets. Duplicar aqui daria duas verdades
// sobre a mesma coisa, e a primeira rede nova entraria em só uma delas.
export { identidadeDaRede };

export const nomeDaRede = (plataforma) => identidadeDaRede(plataforma).rotulo;

// Só estas conversam. As demais entram como conta, mas o inbox unificado da
// Zernio não expõe mensagem direta nelas — dizer isso na tela evita conectar
// e ficar esperando conversa que não vem.
// Fonte 2026-09: TikTok Business entrou (replies only). LinkedIn segue com
// inbox bloqueado pela própria plataforma (terceiros sem acesso a DMs).
export const COM_INBOX = [
  "instagram",
  "facebook",
  "telegram",
  "whatsapp",
  "twitter",
  "reddit",
  "bluesky",
  "tiktok"
];

// Quem aceita comentário em publicação. Fora daqui a aba de comentários não
// tem o que mostrar. LinkedIn organizaion pages também têm comentários
// (doc platforms/linkedin: Inbox (comments) Yes, organization pages only).
export const COM_COMENTARIOS = [
  "instagram",
  "facebook",
  "youtube",
  "tiktok",
  "linkedin"
];

// Quem recebe avaliação de cliente.
export const COM_AVALIACOES = ["facebook", "googlebusiness"];
